module.exports = __webpack_public_path__ + "assets/img/nodata.4096bcd1.png";